import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function TransformationVision() {
  const transformations = ['Tu semana organizada antes del lunes a las 9am', 'Tus correos y propuestas listas en segundos', 'Tu contenido de redes generado y programado', 'Tu rutina personal funcionando en piloto automático', 'Horas libres para lo que realmente importa'];
  return <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{
    once: true
  }} className="text-center" data-id="element-96">
      <h2 className="text-3xl max-sm:text-2xl md:text-4xl font-serif font-bold text-[#E8E0D0] mb-8 max-sm:mb-5" data-id="element-97">
        Imagina tu vida 7 días después de descargar la guía:
      </h2>
      <div className="flex flex-col gap-4 max-sm:gap-3 max-w-2xl mx-auto text-left bg-[#111111] p-8 max-sm:p-5 rounded-2xl max-sm:rounded-xl border border-[#D4AF37]/30 shadow-[0_0_30px_rgba(212,175,55,0.05)]" data-id="element-98">
        {transformations.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-99">
            <CheckCircle2Icon className="w-6 h-6 max-sm:w-5 max-sm:h-5 text-[#D4AF37] shrink-0" data-id="element-100" />
            <span className="text-lg max-sm:text-base text-[#E8E0D0]" data-id="element-101">
              {item}
            </span>
          </div>)}
      </div>
      <p className="text-xl mt-8 font-medium text-[#A09880]" data-id="element-102">
        No es un sueño lejano.
        <br data-id="element-103" />
        <span className="text-[#D4AF37] font-serif font-bold italic" data-id="element-104">
          Es lo que pasa cuando tienes los prompts exactos trabajando por ti. 🧠
        </span>
      </p>
    </motion.div>;
}